import React, { useEffect, useState, useMemo } from 'react';
import defaults from 'lodash/defaults';

const initialPageConfig = {
    title: "",
    hideBackButton: false,
};

const PageConfigContext = React.createContext(null);

// wrapper for the provider
export const PageConfigProvider = ({ children }) => {
    const [pageConfig, setPageConfig] = useState(initialPageConfig);

    const value = useMemo(() => ({
        pageConfig,
        setPageConfig,
    }), [pageConfig, setPageConfig]);
    return (
        <PageConfigContext.Provider value={value}>
            {children}
        </PageConfigContext.Provider>
    );
};

// custom hook
export const usePageConfig = () => React.useContext(PageConfigContext);
export const useSetPageConfig = (pageConfig) => {
    const { setPageConfig } = usePageConfig();
    useEffect(() => {
        setPageConfig((current) => defaults(pageConfig, current));
        return () => {
            setPageConfig(initialPageConfig);
        };
    }, [pageConfig, setPageConfig]);
};
